<script setup>
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import EChart from './EChart.vue'
import { categoryAxis, chartBase, chartTheme, valueAxis } from './chart-theme.js'
import { useAdminTheme } from '../composables/useAdminTheme.js'

const props = defineProps({ items: { type: Array, required: true } })
const { t } = useI18n()
const { theme: themeName } = useAdminTheme()

const option = computed(() => {
  const theme = chartTheme(themeName.value)
  const uv = t('visualGameAdmin.ga4Behavior.summary.unique_visitors')
  const pv = t('visualGameAdmin.ga4Behavior.summary.page_views')
  return {
    ...chartBase(theme),
    color: [theme.bar, theme.info],
    grid: { top: 56, left: 16, right: 16, bottom: 20, containLabel: true },
    legend: { top: 8, textStyle: { color: theme.textMuted }, data: [uv, pv] },
    tooltip: { ...chartBase(theme).tooltip, valueFormatter: value => Number(value).toLocaleString() },
    xAxis: { ...categoryAxis(theme), boundaryGap: false, data: props.items.map(item => item.date), axisLabel: { color: theme.textMuted, hideOverlap: true, formatter: value => value.includes(' ') ? value.slice(11) : value.slice(5) } },
    yAxis: { ...valueAxis(theme), minInterval: 1 },
    series: [
      { name: uv, type: 'line', symbol: 'circle', symbolSize: 6, lineStyle: { width: 2 }, data: props.items.map(item => item.unique_visitors) },
      { name: pv, type: 'line', symbol: 'circle', symbolSize: 6, lineStyle: { width: 2 }, data: props.items.map(item => item.page_views) },
    ],
  }
})
</script>

<template>
  <EChart :option="option" height="340px" />
</template>
